import { render, staticRenderFns } from "./IntegrationPage.vue?vue&type=template&id=524ee4be"
import script from "./IntegrationPage.vue?vue&type=script&lang=js"
export * from "./IntegrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports